import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import Typography from "@mui/material/Typography";

import TableComponent from "../../components/TableComponent";
import useCrew from "../../hooks/useCrew";
import { getOrderCrew } from "../../api/orders";

import OrderItem from "./OrderItem";

const OrdersTable = () => {
  const { t } = useTranslation();
  const [orders, setOrders] = useState([]);
  const { crew } = useCrew();

  useEffect(() => {
    (async () => {
      if (!crew.id) return;
      let newOrders = await getOrderCrew(crew.id, crew.baseIds);
      setOrders(newOrders);
    })();
  }, [crew]);

  return (
    <>
      <Typography component="h2" variant="h4">
        {t("orders.title")}
      </Typography>
      <TableComponent
        header={[
          { title: t("orders.id"), sort: "id", style: { width: "5%" } },
          { title: t("orders.buyer"), sort: "buyer", style: { width: "10%" } },
          { title: t("orders.date"), sort: "date", style: { width: "10%" } },
          { title: t("orders.items"), sort: "items" },
          { title: t("orders.paid_with"), sort: "payment_type" },
          { title: t("orders.total"), style: { width: "5%" } },
          { title: t("orders.status"), sort: "status", style: { width: "10%" } },
          { title: t("orders.invoice"), style: { width: "15%" } },
        ]}
        renderChildren={(order) => <OrderItem key={`order-${order.order_id}`} order={order} />}
        items={orders}
        search={["order_id", "buyer", "status"]}
        pagination
      />
    </>
  );
};

export default OrdersTable;
